import React, { useContext, useEffect, useState } from "react";
// import Dropdown from "react-dropdown";
import Select from "react-select";
import { useParams } from "react-router-dom";

// import "./index.css";
// import { Dropdown, Image } from "react-bootstrap";
// import "bootstrap/dist/css/bootstrap.min.css";
import "react-dropdown/style.css";
import { MasterConfigContext } from "@/context/MasterConfigContext";
import useIsMobile from "@/hooks/useIsMobile";
import HeadTag from "../SeoTags/HeadTag";
import { useRouter } from "next/router";
import WebpageSchema from "../SeoTags/WebpageSchema";

const ResponsiveCard = ({
  constituencyListData = null,
  selectedConstituencyId = "",
  colorCode = "#000",
  constId = null,
}) => {
  //   console.log("current Obj ", constId);
  const redirectUrl = {
    up: "https://www.uptak.in",
    mp: "https://www.mptak.in",
    ch: "https://www.chhattisgarhtak.in",
    rj: "https://www.rajasthantak.com",
    gj: "https://www.gujarattak.in",
    mt: "https://mumbaitak.in",
  };
  const [readMore, setReadMore] = useState(false);
  const [stateList, setStateList] = useState([]);
  const [constList, setConstList] = useState([]);
  const [currentState, setCurrentState] = useState({});
  const [currentConst, setCurrentConst] = useState({});
  //   const [searchParams] = useSearchParams();
  //   const stateID = searchParams.get("state-id");
  const [isChanged, setIsChanged] = useState(false);
  // const website = searchParams.get("website");
  const { regional } = useParams();
  const website = regional;
  const handleReadMoreClick = () => {
    setReadMore(!readMore);
  };
  //   console.log("stateID", website);
  const [dropDownData, setDropdownData] = useState([]);
  const isMobile = useIsMobile();
  useEffect(() => {
    // console.log("constituencyListData", constituencyListData , constId);
    if (constituencyListData) {
      let tempData = [];
      constituencyListData.map((item, index) => {
        tempData.push({
          label: item?.cons_name_hi,
          engName: item?.cons_name,
          value: item?.cons_id,
        });
      });
      setConstList(tempData);
    }
    if (constId) {
      let obj = constituencyListData.filter((item) => item?.cons_id == constId);
      // console.log("the obj is ", obj);
      if (obj && obj[0]) {
        setCurrentConst({
          label: obj[0]?.cons_name_hi,
          engName: obj[0]?.cons_name,
          value: obj[0]?.cons_id,
        });
      }
    }
  }, []);

  useEffect(() => {
    if (isChanged) {
      const data = constituencyListData.filter(
        (item) => item?.cons_id === currentConst?.value
      );
      // console.log("Both are ", currentConst , data);
      window.open(
        `${process?.env?.NEXT_PUBLIC_WEBSITE_URL
        }/elections/haryana-assembly/constituencies/${data[0]?.cons_name
          .toLowerCase()
          .replace(/[^a-zA-Z ]/g, "")
          .split(" ")
          .join("-")}-constituency-result-${currentConst?.value}`,
        "_self"
      );
    }
  }, [currentConst]);

  const customFilterOption = (option, searchText) => {
    if (
      option.data.label.toLowerCase().includes(searchText.toLowerCase()) ||
      option.data.engName.toLowerCase().includes(searchText.toLowerCase())
    ) {
      return true;
    }
    return false;
  };

  const fullText = `अगर प्रदेश का एक प्रमुख नगर और हिस्टा है वाराणसी बासास और काशी के नाम से भी जाना जाता है. इस हिस्टा में एक पतन नगर माना जाता है. ठंड और उमस के लिए भी एक महत्वपूर्ण शहर है...
  अगर प्रदेश का एक प्रमुख नगर और हिस्टा है वाराणसी बासास और काशी के नाम से भी जाना जाता है. इस हिस्टा में एक पतन नगर माना जाता है. ठंड और उमस के लिए भी एक महत्वपूर्ण शहर है
  अगर प्रदेश का एक प्रमुख नगर और हिस्टा है वाराणसी बासास और काशी के नाम से भी जाना जाता है. इस हिस्टा में एक पतन नगर माना जाता है. ठंड और उमस के लिए भी एक महत्वपूर्ण शहर है`;
  const previewText = `अगर प्रदेश का एक प्रमुख नगर और हिस्टा है वाराणसी...`;
  // console.log("after useEffect", currentConst?.label);
  return (
    <div className="responsive-card shadow-sm">
      {/* <h6
        className="text-muted"
        style={{ fontSize: "12px", paddingBottom: "10px" }}
      >
        वाराणसी
      </h6> */}
      {/* <Dropdown className="w-100 rounded-2">
        <Dropdown.Toggle
          variant="light"
          id="dropdown-basic"
          className="w-100 text-start border border-light border-1 bg-white "
        >
          वाराणसी
        </Dropdown.Toggle>
        <Dropdown.Menu defaultValue={selectedConstituencyId} className="w-100">
          {constituencyListData &&
            constituencyListData.map((item, index) => (
              <Dropdown.Item value={item?.cons_id} key={index} as="button">
                {item?.cons_name_hi}
              </Dropdown.Item>
            ))}
        </Dropdown.Menu>
      </Dropdown> */}
      {/* <h5>Select State</h5>
      <Dropdown
        onChange={(e) => {
          setCurrentState(e);
        }}
        options={stateList}
        value={currentState?.label}
        disabled={stateID ? true : false}
        placeholder="Select an option"
      /> */}
      <br></br>
      <h5 style={{ fontSize: "1.25rem" }}>Select Constituency</h5>
      {/* <Dropdown
        onChange={(e) => {
          setCurrentConst(e);
          setIsChanged(true);
        }}
        options={constList}
        value={currentConst?.label}
        disabled={currentState ? false : true}
        placeholder="Select an option"
      /> */}
      <Select
        onChange={(e) => {
          setCurrentConst(e);
          setIsChanged(true);
        }}
        options={constList}
        value={currentConst}
        placeholder="Select an option"
        isSearchable={true}
        filterOption={customFilterOption}
      />

      {/* <div className="map__image_box">
        <img src="/city_map.svg" alt="Map" fluid className="mt-3" />
      </div> */}

      {/* <div className="card-text mt-3">
        {readMore ? fullText : previewText}
        <button
          onClick={handleReadMoreClick}
          className="btn btn-link p-0 align-baseline"
          style={{ color: colorCode }}
        >
          {readMore ? "और पढ़ें कम" : "और पढ़ें"}
        </button>
      </div> */}
    </div>
  );
};

const RegionalsConstituencyResultsComponent = ({
  electionPassedCategory = "",
  masterKey = "",
  constituencyTempListData = [],
  candidateData = [],
  constituencyDetailData = [],
  constHindiName = "",
  constituencyName = "",
  stateName = "",
}) => {
  const router = useRouter();
  const isFiveStates = ["west-bengal", "assam", "tamil-nadu", "puducherry", "kerala"].some((state) => router?.asPath?.includes(state));
  const isDelhi = router?.asPath.includes("delhi");
  const isBihar = router?.asPath.includes("bihar");
  const isMaharashtra = router?.asPath.includes("maharashtra");
  const isHaryana = router?.asPath.includes("haryana");
  const isJharkhand = router?.asPath.includes("jharkhand");
  // console.log("the prop data is " , electionPassedCategory , masterKey , constituencyTempListData , candidateData , constituencyDetailData);
  const [candidatesList2024, setCandidatesList2024] = useState([]);
  const [constituencyData, setConstituencyData] = useState(null);
  const [constituencyListData, setConstituencyListData] = useState(null);
  const [resultYearData, setResultYearData] = useState([]);
  const [currentYear, setCurrentYear] = useState(
    (isBihar || isDelhi)
      ? "2020"
      : (isMaharashtra || isHaryana || isJharkhand)
        ? "2019"
        : isFiveStates ? "2021" : ""
  );
  const [winningCandidate, setWinningCandidate] = useState({});
  // const [prevData, setPrevData] = useState([]);
  //   const [searchParams] = useSearchParams();
  const masterConfig = useContext(MasterConfigContext);
  const electionKeys = masterConfig[masterKey];
  const showCandidatePrfile = electionKeys?.showCandidateProfile;
  const [constituencyId, setConstituencyId] = useState("");
  //  console.log("candidatesList2024",candidatesList2024)
  useEffect(() => {
    if (typeof window !== "undefined") {
      const getLastSegmentFromCurrentUrl = () => {
        const url = window.location.href;
        let tempUrl = url.split("?")[0];
        const cleanUrl = tempUrl.trim().replace(/\/$/, "");
        const segments = cleanUrl.split("/");
        return segments.pop();
      };

      const segment = getLastSegmentFromCurrentUrl();
      let tempId = segment.split("-");

      setConstituencyId(tempId[tempId.length - 1]);

      if (
        electionKeys?.constDetailYear == 2026 || electionKeys?.constDetailYear == 2025 ||
        electionKeys?.constDetailYear == 2024
      ) {
        getCandidatesListProd(tempId[tempId.length - 1]);
        const interval = setInterval(() => {
          getCandidatesListProd(tempId[tempId.length - 1]);
        }, 30000);

        // console.log("Polling started");
        return () => clearInterval(interval);
      }
    }
  }, []);
  const { regional } = useParams();
  //   console.log('the id is' , constituencyId)
  //   const website = searchParams.get("website");
  //   console.log("CONSTITUENCY DATA ", resultYearData);
  const colorOptions = {
    llt: "#eb0e8c",
    tg: "#d9368b",
    mz: "#8ab3dc",
    mp: "#0c8a70",
    cg: "#2d8468",
    llt: "#d9368b",
    rj: "#fed029",
    up: "#f6523e",
    gj: "#f362b3",
    ct: "#B71F33",
    mt: "#f92929",
    br: "#CF4C9B",
  };
  // const options = [
  //   {
  //     value: 0,
  //     label: "2019",
  //   },
  //   // {
  //   //   value: 2,
  //   //   label: '2024'
  //   // }
  // ];
  // const getConstituencyData = async (id) => {
  //   try {
  //     let url = `https://akm-img-a-in.tosshub.com/sites/elections/2024/assembly/json/constituency/haryana/${id}.json`;
  //     await fetch(url).then(async (data) => {
  //       const data1 = await data.json();
  //       setConstituencyData(data1?.data);
  //       setResultYearData(data1?.data?.candidate_2019);
  //     });
  //   } catch (error) {
  //     console.log("error in constituency data");
  //   }
  // };
  //   async function getConstituencyData(constituencyId = "") {
  //     let url = `https://akm-img-a-in.tosshub.com/sites/elections/2024/loksabha/json/constituency/${constituencyId}.json`;
  //     await fetch(url).then(async (data) => {
  //       const data1 = await data.json();
  //       console.log("data", data1);
  //       setConstituencyData(data1?.data);
  //       setResultYearData(data1?.data?.candidate_2019);
  //     });
  //   }
  // const getCandidatesList = async (id) => {
  //   try {
  //     // console.log("Inside find function");
  //     let url =  `https://electionresults.intoday.in/elections/2024/assembly-elections/json/constituency-tak/${id}.json` ;
  //     await fetch(url).then(async (data) => {
  //       const data1 = await data.json();
  //         console.log("candidatesList in alpha", data1?.data?.candidate);
  //       // setCandidatesList2024(data1?.data?.candidate);
  //     });
  //   } catch (error) {
  //     console.log("error in candidate list");
  //   }
  // };
  const makeSlug = (text) =>
    text?.trim()?.toLowerCase()?.replace(/\s+/g, "-");
  const getCandidatesListProd = async (id) => {
    try {
      // console.log("Inside find function");https://electionresults.intoday.in/elections/2025/assembly-elections/json/constituency-tak/30001.json
      let url = isFiveStates ? (electionKeys?.isElectionAlpha
        ?
        `https://electionresults.intoday.in/elections/${electionKeys?.constDetailYear}/assembly-elections/json/constituency-alpha/${makeSlug(stateName)}/${id}.json`
        : `https://electionresults.intoday.in/elections/2026/assembly-elections/json/constituency-tak/${makeSlug(stateName)}/${id}.json`)
        // this apis for bihar and other prevous states
        : (electionKeys?.isElectionAlpha ? `https://electionresults.intoday.in/elections/2025/assembly-elections/json/constituency-livblog/${id}.json`
          : `https://electionresults.intoday.in/elections/2025/assembly-elections/json/constituency-tak/${id}.json`);

      await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }).then(async (data) => {
        const data1 = await data.json();
        // console.log("candidatesList", data1?.data);
        setCandidatesList2024(data1?.data?.candidate);
        setWinningCandidate(data1?.data?.candidate[0]);
      });
    } catch (error) {
      console.log("error in candidate list");
    }
  };
  //   async function getCandidatesList(constituencyId) {
  //     console.log("Inside find function");
  //     let url = `https://electionresults.intoday.in/elections/2024/loksabha-elections/json/constituency/${constituencyId}.json`;
  //     await fetch(url).then(async (data) => {
  //       const data1 = await data.json();
  //       console.log("candidatesList", data1?.data?.candidate);
  //       setCandidatesList2024(data1?.data?.candidate);
  //     });
  //   }

  // const getConstituencyListData = async () => {
  //   try {
  //     let url = `https://akm-img-a-in.tosshub.com/sites/elections/2024/assembly/json/state-master/haryana-state-master.json`;
  //     await fetch(url).then(async (data) => {
  //       const data1 = await data.json();
  //       //   console.log("constituencyListData", data1?.data);
  //       setConstituencyListData(data1?.data);
  //     });
  //   } catch (error) {
  //     console.log("error in getConstituencyListData");
  //   }
  // };
  //   async function getConstituencyListData() {

  //   }
  //   useEffect(() => {
  //     getConstituencyListData();
  //     if (constituencyId) {
  //     //   getConstituencyData(constituencyId);
  //     //   getCandidatesList(constituencyId);
  //     }
  //   }, []); 
  useEffect(() => {
    if (currentYear === "2019") {
      setResultYearData(constituencyDetailData?.candidate_2019);
    } else if (currentYear === "2014") {
      setResultYearData(constituencyDetailData?.candidate_2014);
    } else if (currentYear === "2015") {
      setResultYearData(constituencyDetailData?.candidate_2015);
    } else if (currentYear === "2016") {
      setResultYearData(constituencyDetailData?.candidate_2016);
    }
    else if (currentYear === "2024") {
      setResultYearData(constituencyDetailData?.candidate_2024);
    } else if (currentYear === "2020") {
      setResultYearData(constituencyDetailData?.candidate_2020);
    } else if (currentYear === "2025") {
      setResultYearData(constituencyDetailData?.candidate_2025);
    } else if (currentYear === "2026") {
      setResultYearData(constituencyDetailData?.candidate_2026);
    } else if (currentYear === "2021") {
      setResultYearData(constituencyDetailData?.candidate_2021);
    }
    else {
      setResultYearData([]);
    }
  }, [currentYear]);
  // console.log("candi", constituencyDetailData,resultYearData);
  const isMobile = useIsMobile();
  const const_year = electionKeys?.constListPageMetaYear || electionKeys?.constDetailYear;
  //  const constituencyNameCapitalCase=winningCandidate?.ac_name?.charAt(0).toUpperCase() + winningCandidate?.ac_name?.slice(1)?.toLowerCase();
  let metaData = {
    title: `${constituencyName} Assembly Election ${const_year}:Winner, Vote Share, MLA, Party & Full Details |  ${constHindiName} विधानसभा चुनाव परिणाम ${const_year} - Newstak`,
    description:
      winningCandidate?.win_loss == "WON"
        ? `${constituencyName} Vidhan Sabha Chunav Result ${const_year}: ${constHindiName} विधानसभा चुनाव ${const_year} में ${winningCandidate?.party_h
        } के ${winningCandidate?.candidate_h} ने ${candidatesList2024?.[1]?.party_h
        } के ${candidatesList2024?.[1]?.candidate_h} को ${candidatesList2024?.[0]?.votes - candidatesList2024?.[1]?.votes
        } वोटों से हराया। जानिए किस उम्मीदवार को कितने वोट मिले, वोट शेयर, जीत का मार्जिन और सभी जरूरी अपडेट सिर्फ Newstak.in पर।`
        : `${constituencyName || candidateData?.[0]?.ac_name} Vidhan Sabha Chunav Result ${const_year}: ${constHindiName} विधानसभा चुनाव ${const_year} के नतीजे LIVE - जानिए कौन उम्मीदवार कितने वोटों से आगे चल रहा है, किसे कितने वोट मिले और जीत-हार का पूरा अपडेट सिर्फ Newstak.in पर।`,
    keywords: `${constituencyName || candidateData?.[0]?.ac_name} election news, ${constituencyName || candidateData?.[0]?.ac_name} election result ${const_year}, ${constituencyName || candidateData?.[0]?.ac_name} assembly election winner, ${constituencyName || candidateData?.[0]?.ac_name} vote share, Bihar election ${const_year} result, ${constituencyName || candidateData?.[0]?.ac_name} vidhan sabha seat result, ${constituencyName || candidateData?.[0]?.ac_name} MLA result, ${constituencyName || candidateData?.[0]?.ac_name} live vote count, ${constHindiName} विधानसभा नतीजे, ${constHindiName} विधानसभा चुनाव, ${constHindiName} विधानसभा चुनाव परिणाम, ${constHindiName} विधानसभा चुनाव परिणाम ${const_year}`,
  };
  // console.log("constituencyListData===", constituencyDetailData?.candidate_2021);

  const currentPath = router?.asPath?.split("?")[0];
  const previousConstitencyData = constituencyDetailData?.candidate_2019?.length > 0 || constituencyDetailData?.candidate_2020?.length > 0 || constituencyDetailData?.candidate_2021?.length > 0 || constituencyDetailData?.candidate_2024?.length > 0 || constituencyDetailData?.candidate_2025?.length > 0 || constituencyDetailData?.candidate_2026?.length > 0 || constituencyDetailData?.candidate_2014?.length > 0 || constituencyDetailData?.candidate_2015?.length > 0 || constituencyDetailData?.candidate_2016?.length > 0;
  return (
    <>
      <HeadTag
        title={metaData?.title}
        description={metaData?.description}
        keywords={metaData?.keywords}
      // canonicalUrl={process.env.NEXT_PUBLIC_WEBSITE_URL + currentPath}
      // image={categoryNewsListData?.seo_detail?.og_image}
      />
      <WebpageSchema
        title={metaData?.title}
        description={metaData?.description}
        keywords={metaData?.keywords}
        canonicalUrl={process.env.NEXT_PUBLIC_WEBSITE_URL + currentPath}
      />
      <div className="result-page">
        {/* <h2 style={{ fontSize: "22px", fontWeight: "700" }}>
          लोकसभा चुनाव ({constituencyData?.constituency_name})
        </h2> */}
        {constituencyListData && (
          <ResponsiveCard
            constituencyListData={constituencyTempListData}
            selectedConstituencyId={constituencyId}
            colorCode={"#CF4C9B"}
            constId={constituencyId}
          />
        )}
        {candidatesList2024.length > 0 && (
          <div className="winners-list-box" style={{ margin: "20px 0px" }}>
            <h3
              style={{
                letterSpacing: "normal",
                fontSize: "1.5rem",
                marginTop: "4px",
                marginBottom: "4px",
                fontWeight: 600,
              }}
            >
              {constHindiName} चुनाव {electionKeys?.constDetailYear} के
              उम्मीदवार
            </h3>
            {winningCandidate && winningCandidate?.status == "WON" && (
              <div className="winner-box" style={{ margin: "20px 0px" }}>
                <div className="winner-box-heading">
                  <div style={{ alignSelf: "center", fontSize: "18px" }}>
                    विजेता
                  </div>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                    }}
                  >
                    <div style={{ fontSize: "18px", textAlign: "right" }}>
                      {winningCandidate && winningCandidate?.candidate}{" "}
                      {winningCandidate && winningCandidate?.party}
                    </div>
                    <img
                      width="38"
                      height="38"
                      className="rounded-full object-cover"
                      src={winningCandidate && winningCandidate?.party_logo}
                    ></img>
                  </div>
                </div>
                <div className="winner-box-heading-2">
                  <div style={{ alignSelf: "center" }}>वोट</div>
                  <div style={{ fontSize: "16px", alignSelf: "center" }}>
                    {winningCandidate && winningCandidate?.votes}
                  </div>
                </div>
                {/* <div className="winner-box-heading-2">
                <div style={{ alignSelf: "center" }}>विजेता पार्टी का वोट %</div>
                <div style={{ fontSize: "15px", alignSelf: "center" }}>
                  {winningCandidate && winningCandidate?.percentage_votes} %
                </div>
              </div>
              <div
                className="winner-box-heading-2"
                style={{
                  borderBottomLeftRadius: "10px",
                  borderBottomRightRadius: "10px",
                }}
              >
                <div style={{ alignSelf: "center" }}>जीत अंतर %</div>
                <div style={{ fontSize: "15px", alignSelf: "center" }}>
                  {winningCandidate && winningCandidate?.winning_percentage} %
                </div>
              </div> */}
              </div>
            )}
            <table>
              <th
                style={{
                  backgroundColor: isBihar
                    ? "#CF4C9B"
                    : isHaryana
                      ? "#64BC46"
                      : "#EE3436",
                  // textAlign: "left",
                  width: "40%",
                }}
              >
                नाम
              </th>
              <th style={{
                background: isBihar
                  ? "#CF4C9B"
                  : isHaryana
                    ? "#64BC46"
                    : "#EE3436", width: "30%"
              }}>
                पार्टी
              </th>
              <th style={{
                background: isBihar
                  ? "#CF4C9B"
                  : isHaryana
                    ? "#64BC46"
                    : "#EE3436"
              }}>वोट</th>
              {electionKeys?.isElectionAlpha
                ? candidatesList2024.map((candidate, index) => {
                  return (
                    <tr
                      className={index % 2 !== 0 ? "oddColor" : ""}
                      key={index}
                    // onClick={() =>
                    //   (window.location = `/elections/constituency-list-2019/${con?.ac_no}`)
                    // }
                    >
                      <td>
                        {showCandidatePrfile ? (
                          candidate?.candidate == "NOTA" ||
                            candidate?.candidate
                              ?.toLowerCase()
                              .includes("ota") ? (
                            <div
                              style={{
                                display: "flex",
                                justifyContent: isMobile
                                  ? "center"
                                  : "center",
                                flexDirection: isMobile ? "column" : "row",
                                alignItems: "center",
                                textAlign: "center",
                                 
                              }}
                            >
                              {candidate?.status_logo && (
                                <img
                                  src={candidate?.status_logo}
                                  style={{
                                    display: "inline",
                                    marginRight: "5px",
                                  }}
                                  width="15px"
                                  height="15px"
                                ></img>
                              )}
                              {candidate?.candidate_h}
                            </div>
                          ) : (
                            <a
                              className={`align-center underline ${isBihar ? "hover:text-[#CF4C9B]" : 'hover:text-primary'} hover:underline`}
                              href={`${process?.env?.NEXT_PUBLIC_WEBSITE_URL
                                }/elections/${electionPassedCategory}/candidates/${candidate?.candidate

                                  ?.toLowerCase()
                                  .replace(/[^a-zA-Z ]/g, "")
                                  .split(" ")
                                  .join(
                                    "-"
                                  )}-result-${constituencyDetailData?.constituency_name

                                    ?.toLowerCase()
                                    .replace(/[^a-zA-Z ]/g, "")
                                    .split(" ")
                                    .join("-")}-${constituencyId}-${candidate?.id
                                }`}
                            >
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: isMobile
                                    ? "center"
                                    : "center",
                                  flexDirection: isMobile ? "column" : "row",
                                  alignItems: "center",
                                  textAlign: "center",
                                  gap: "3px",
                                }}
                                className="hover:underline  "
                              >
                                {candidate?.status_logo && (
                                  <img
                                    src={candidate?.status_logo}
                                    style={{
                                      display: "inline",
                                      marginRight: "5px",
                                      width: "20px",
                                      height: "20px",
                                      marginTop: "5px",
                                    }}
                                  ></img>
                                )}
                                {candidate?.candidate_h}
                              </div>
                            </a>
                          )
                        ) : (
                          <div
                            style={{
                              display: "flex",
                              justifyContent: isMobile ? "center" : "center",
                              flexDirection: isMobile ? "column" : "row",
                              alignItems: "center",
                              textAlign: "center",
                            }}
                          >
                            {candidate?.status_logo && (
                              <img
                                src={candidate?.status_logo}
                                style={{
                                  display: "inline",
                                  marginRight: "5px",
                                }}
                                width="15px"
                                height="10px"
                              ></img>
                            )}
                            {candidate?.candidate_h}
                          </div>
                        )}
                      </td>
                      <td
                        className={`gap-2 ${isMobile
                          ? "justify-items-center text-center"
                          : " candidate_party  justify-items-center whitespace-nowrap   "
                          } `}
                      >
                        <img
                          className=" w-[20px] h-[20px] rounded-full "
                          // width="20"
                          // height="20"
                          // style={{ borderRadius: "100%" }}
                          src={candidate?.party_logo}
                        ></img>
                        {candidate?.party}
                      </td>
                      <td
                        className="winner-name"
                        style={{
                          textAlign: "center",
                          borderLeftColor: "#d2d1d1",
                          borderLeftWidth: "0.2px",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            gap: "10px",
                            margin: "auto",
                            width: "auto",
                            justifyContent: "center",
                          }}
                        >
                          <p style={{ margin: "0", fontSize: "16px" }}>
                            {candidate?.votes}
                          </p>{" "}
                        </div>
                      </td>
                    </tr>
                  );
                })
                : candidatesList2024.map((candidate, index) => {
                  return (
                    <tr
                      className={index % 2 !== 0 ? "oddColor" : ""}
                      key={index}
                    // onClick={() =>
                    //   (window.location = `/elections/constituency-list-2019/${con?.ac_no}`)
                    // }
                    >
                      <td>
                        {showCandidatePrfile ? (
                          candidate?.candidate === "NOTA" ||
                            candidate?.candidate
                              ?.toLowerCase()
                              .includes("nota") ? (
                            <div
                              style={{
                                display: "flex",
                                justifyContent: isMobile
                                  ? "center"
                                  : "center",
                                flexDirection: isMobile ? "column" : "row",
                                alignItems: "center",
                                textAlign: "center",
                              }}
                            >
                              {candidate?.status_logo && (
                                <img
                                  src={candidate?.status_logo}
                                  style={{
                                    display: "inline",
                                    marginRight: "5px",
                                  }}
                                  width="15px"
                                  height="15px"
                                ></img>
                              )}
                              {candidate?.candidate_h}
                            </div>
                          ) : (
                            <a
                              className={`align-center underline ${isBihar ? "hover:text-[#CF4C9B]" : 'hover:text-primary'} hover:underline`}
                              href={`${process?.env?.NEXT_PUBLIC_WEBSITE_URL
                                }/elections/${electionPassedCategory}/candidates/${candidate?.candidate

                                  ?.toLowerCase()
                                  .replace(/[^a-zA-Z ]/g, "")
                                  .split(" ")
                                  .join(
                                    "-"
                                  )}-result-${constituencyDetailData?.constituency_name

                                    ?.toLowerCase()
                                    .replace(/[^a-zA-Z ]/g, "")
                                    .split(" ")
                                    .join("-")}-${constituencyId}-${candidate?.id
                                }`}
                            >
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: isMobile
                                    ? "center"
                                    : "center",
                                  flexDirection: isMobile ? "column" : "row",
                                  alignItems: "center",
                                  textAlign: "center",
                                }}
                                className="hover:underline "
                              >
                                {candidate?.status_logo && (
                                  <img
                                    src={candidate?.status_logo}
                                    style={{
                                      display: "inline",
                                      marginRight: "5px",
                                    }}
                                    width="15px"
                                    height="10px"
                                  ></img>
                                )}
                                {candidate?.candidate_h}
                              </div>
                            </a>
                          )
                        ) : (
                          <div
                            style={{
                              display: "flex",
                              justifyContent: isMobile ? "center" : "center",
                              flexDirection: isMobile ? "column" : "row",
                              alignItems: "center",
                              textAlign: "center",
                            }}
                          >
                            {candidate?.status_logo && (
                              <img
                                src={candidate?.status_logo}
                                style={{
                                  display: "inline",
                                  marginRight: "5px",
                                }}
                                width="15px"
                                height="10px"
                              ></img>
                            )}
                            {candidate?.candidate_h}
                          </div>
                        )}
                      </td>
                      <td
                        className={`gap-2 ${isMobile
                          ? "justify-items-center text-center"
                          : " candidate_party justify-items-center whitespace-nowrap  "
                          } `}
                      >
                        <img
                          className=" w-[20px] h-[20px] rounded-full  "
                          src={candidate?.party_logo}
                        ></img>
                        {candidate?.party}
                      </td>
                      <td
                        className="winner-name"
                        style={{
                          textAlign: "center",
                          borderLeftColor: "#d2d1d1",
                          borderLeftWidth: "0.2px",
                        }}
                      >
                        {candidate?.win_loss === "Result Awaited" ? (
                          "-"
                        ) : (
                          <div
                            style={{
                              display: "flex",
                              gap: "10px",
                              margin: "auto",
                              width: "auto",
                              justifyContent: "center",
                            }}
                          >
                            <p style={{ margin: "0", fontSize: "16px" }}>
                              {candidate?.votes}
                            </p>{" "}
                          </div>
                        )}
                      </td>
                    </tr>
                  );
                })}
            </table>
          </div>
        )}
        {/* <br></br> */}
        {previousConstitencyData && <div className="my-2">
          <h2
            className="winner-box-header  "
            style={{
              borderColor: isBihar
                ? "#CF4C9B"
                : isHaryana
                  ? "#64BC46"
                  : "#EE3436"
            }}
          >
            {constHindiName} विधानसभा सीट परिणाम {currentYear}
          </h2>
          <br></br>
          <div className="winner-box-years">
            {constituencyDetailData?.candidate_2026 && (
              <button
                className={`${currentYear !== "2026" ? "btn-disable" : ""}`}
                onClick={() => setCurrentYear("2026")}
                style={{
                  backgroundColor: isBihar
                    ? "#CF4C9B"
                    : isHaryana
                      ? "#64BC46"
                      : "#EE3436"
                }}
              >
                2026
              </button>
            )}
            {constituencyDetailData?.candidate_2025 && (
              <button
                className={`${currentYear !== "2025" ? "btn-disable" : ""}`}
                onClick={() => setCurrentYear("2025")}
                style={{
                  backgroundColor: isBihar
                    ? "#CF4C9B"
                    : isHaryana
                      ? "#64BC46"
                      : "#EE3436"
                }}
              >
                2025
              </button>
            )}
            {constituencyDetailData?.candidate_2024 && (
              <button
                className={`${currentYear !== "2024" ? "btn-disable" : ""}`}
                onClick={() => setCurrentYear("2024")}
                style={{
                  backgroundColor: isBihar
                    ? "#CF4C9B"
                    : isHaryana
                      ? "#64BC46"
                      : "#EE3436"
                }}
              >
                2024
              </button>
            )}
            {constituencyDetailData?.candidate_2021 && (
              <button
                className={`${currentYear !== "2021" ? "btn-disable" : ""}`}
                onClick={() => setCurrentYear("2021")}
                style={{
                  backgroundColor: isBihar
                    ? "#CF4C9B"
                    : isHaryana
                      ? "#64BC46"
                      : "#EE3436"
                }}
              >
                2021
              </button>
            )}
            {constituencyDetailData?.candidate_2020 && (
              <button
                className={`${currentYear !== "2020" ? "btn-disable" : ""}`}
                onClick={() => setCurrentYear("2020")}
                style={{
                  backgroundColor: isBihar
                    ? "#CF4C9B"
                    : isHaryana
                      ? "#64BC46"
                      : "#EE3436"
                }}
              >
                2020
              </button>
            )}
            {constituencyDetailData?.candidate_2019 && (
              <button
                className={`${currentYear !== "2019" ? "btn-disable" : ""}`}
                onClick={() => setCurrentYear("2019")}
                style={{
                  backgroundColor: isBihar
                    ? "#CF4C9B"
                    : isHaryana
                      ? "#64BC46"
                      : "#EE3436"
                }}
              >
                2019
              </button>
            )}
            {constituencyDetailData?.candidate_2016 && (
              <button
                className={`${currentYear !== "2016" ? "btn-disable" : ""}`}
                onClick={() => setCurrentYear("2016")}
                style={{
                  backgroundColor: isBihar
                    ? "#CF4C9B"
                    : isHaryana
                      ? "#64BC46"
                      : "#EE3436"
                }}
              >
                2016
              </button>
            )}
            {constituencyDetailData?.candidate_2015 && (
              <button
                className={`${currentYear !== "2015" ? "btn-disable" : ""}`}
                onClick={() => setCurrentYear("2015")}
                style={{
                  backgroundColor: isBihar
                    ? "#CF4C9B"
                    : isHaryana
                      ? "#64BC46"
                      : "#EE3436"
                }}
              >
                2015
              </button>
            )}
            {constituencyDetailData?.candidate_2014 && (
              <button
                className={`${currentYear !== "2014" ? "btn-disable" : ""}`}
                onClick={() => setCurrentYear("2014")}
                style={{
                  backgroundColor: isBihar
                    ? "#CF4C9B"
                    : isHaryana
                      ? "#64BC46"
                      : "#EE3436"
                }}
              >
                2014
              </button>
            )}
          </div>
          <div className="winner-box">
            <div className="winner-box-heading">
              <div style={{ alignSelf: "center" }}>विजेता</div>
              <div
                style={{ display: "flex", alignItems: "center", gap: "5px" }}
              >
                <div style={{ fontSize: "15px" }}>
                  {resultYearData && resultYearData[0]?.candidate}{" "}
                  {resultYearData && resultYearData[0]?.party}
                </div>
                <img
                  width="38"
                  height="38"
                  className="rounded-full object-cover"
                  src={resultYearData && resultYearData[0]?.party_logo}
                ></img>
              </div>
            </div>
            <div className="winner-box-heading-2">
              <div style={{ alignSelf: "center" }}>वोट</div>
              <div style={{ fontSize: "16px", alignSelf: "center" }}>
                {resultYearData && resultYearData[0]?.votes}
              </div>
            </div>
            <div className="winner-box-heading-2">
              <div style={{ alignSelf: "center" }}>विजेता पार्टी का वोट %</div>
              <div style={{ fontSize: "16px", alignSelf: "center" }}>
                {resultYearData && resultYearData[0]?.percentage_votes} %
              </div>
            </div>
            <div
              className="winner-box-heading-2"
              style={{
                borderBottomLeftRadius: "10px",
                borderBottomRightRadius: "10px",
              }}
            >
              <div style={{ alignSelf: "center" }}>जीत अंतर %</div>
              <div style={{ fontSize: "16px", alignSelf: "center" }}>
                {resultYearData && resultYearData[0]?.winning_percentage} %
              </div>
            </div>
          </div>
        </div>}
        <br></br>
        {resultYearData?.length > 0 && <div className="winners-list-box">
          <div
            className="winner-box-header"
            style={{
              borderColor: isBihar
                ? "#CF4C9B"
                : isHaryana
                  ? "#64BC46"
                  : "#EE3436"
            }}
          >
            {constHindiName} से अन्य उम्मीदवार
          </div>
          <br></br>
          <div>
            <table class="rounded-3 overflow-hidden">
              <th
                style={{
                  backgroundColor: isBihar
                    ? "#CF4C9B"
                    : isHaryana
                      ? "#64BC46"
                      : "#EE3436",
                  // textAlign: "left",
                  width: "40%",
                }}
              >
                नाम
              </th>
              <th
                style={{
                  backgroundColor: isBihar
                    ? "#CF4C9B"
                    : isHaryana
                      ? "#64BC46"
                      : "#EE3436",
                  textAlign: "center",
                  borderLeftColor: "white",
                  borderLeftWidth: "1px",
                }}
              >
                पार्टी
              </th>
              <th
                style={{
                  backgroundColor: isBihar
                    ? "#CF4C9B"
                    : isHaryana
                      ? "#64BC46"
                      : "#EE3436",
                  textAlign: "center",
                  borderLeftColor: "white",
                  borderLeftWidth: "1px",
                }}
              >
                वोट
              </th>
              {constituencyDetailData &&
                resultYearData?.slice(1).map((con, index) => {
                  return (
                    <tr
                      className={index % 2 !== 0 ? "oddColor" : ""}
                      key={index}
                    // style={{ cursor: "pointer" }}
                    // onClick={() =>
                    //   (window.location = `/elections/constituency-list-2019/${con?.ac_no}`)
                    // }
                    >
                      <td
                        style={{
                          textAlign: "center",
                        }}
                      >
                        {con?.candidate_h}
                      </td>
                      <td
                        style={{
                          textAlign: "center",
                          color: "black",
                          borderLeftColor: "#d2d1d1",
                          borderLeftWidth: "0.2px",
                        }}
                      >
                        {con?.party}
                      </td>
                      <td
                        className="winner-name"
                        style={{
                          textAlign: "center",
                          borderLeftColor: "#d2d1d1",
                          borderLeftWidth: "0.2px",
                          fontSize: "16px",
                        }}
                      >
                        {con?.votes}
                      </td>
                    </tr>
                  );
                })}
            </table>
          </div>
        </div>}
      </div>
    </>
  );
};

export default RegionalsConstituencyResultsComponent;
